module.exports = __webpack_public_path__ + "img/slide-37.d646698a.jpeg";